import { Badge } from '@mantine/core';

import { ProductEnum } from '@/api';

import { productTypeLabel } from '../helpers';

type ProductTypeBadgeProps = {
  productType: ProductEnum;
};

type ProductTypeStyle = { color: string; border: string; bg: string };

const DEFAULT_STYLE: ProductTypeStyle = {
  color: 'var(--mantine-color-gray-9)',
  border: 'var(--mantine-color-gray-3)',
  bg: 'var(--mantine-color-gray-0)',
};

const STYLE_BY_PRODUCT: Partial<Record<ProductEnum, ProductTypeStyle>> = {
  [ProductEnum.POPUP]: {
    color: 'var(--mantine-color-yellow-9)',
    border: 'var(--mantine-color-orange-3)',
    bg: 'var(--mantine-color-orange-0)',
  },
  [ProductEnum.DELIVERY]: {
    color: 'var(--mantine-color-cyan-9)',
    border: 'var(--mantine-color-cyan-3)',
    bg: 'var(--mantine-color-cyan-0)',
  },
  [ProductEnum.CATERING]: {
    color: 'var(--mantine-color-grape-9)',
    border: 'var(--mantine-color-grape-3)',
    bg: 'var(--mantine-color-grape-0)',
  },
};

export const ProductTypeBadge: React.FC<ProductTypeBadgeProps> = ({ productType }) => {
  const { color, border, bg } = STYLE_BY_PRODUCT[productType] ?? DEFAULT_STYLE;

  return (
    <Badge
      variant="light"
      radius="sm"
      size="md"
      styles={{
        label: { textTransform: 'none', color },
        root: { border: `1px solid ${border}`, backgroundColor: bg },
      }}
    >
      {productTypeLabel(productType)}
    </Badge>
  );
};

